import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingPage } from "../ui/loading-page";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // If we're still loading, show a loading spinner
  if (isLoading) {
    return <LoadingPage message="Checking authentication..." />;
  }

  // If not authenticated, redirect to login page with the return URL
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default ProtectedRoute; 